import {
  Box,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import COLORS from '../../resources/style/Themes';
import { handleEnterKeyPress } from '../../utils/app_support/KeyPressHandler';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../resources/strings/StringKeys';

const BaseModal = ({
  open,
  onClose,
  title,
  children,
  submitButtonText,
  onSubmit,
  showFooter = true,
  size = 'md',
  footerContent = undefined,
  enableEnterKey = true,
  showCloseButton = true,
  sx = {},
}) => {
  const { t } = useTranslation();

  const handleEnterPress = (e) => {
    if (enableEnterKey && onSubmit) {
      handleEnterKeyPress(onSubmit)(e);
    }
  };

  return (
    <Dialog
      open={open}
      maxWidth={size}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      sx={sx}
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: 'hidden',
        },
      }}
    >
      {/* Header Section */}

      <DialogTitle
        id="modal-title"
        sx={{
          backgroundColor: COLORS.SAFEGUARD_BLUE,
          color: COLORS.WHITE,
          m: '0 0 1rem 0',
          p: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2,
        }}
      >
        {title}
        {showCloseButton && (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              color: COLORS.WHITE,

              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
              },
            }}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>

      {/* Content Section */}
      <DialogContent component="div" onKeyDown={handleEnterPress}>
        {children}
      </DialogContent>

      {/* Footer Section */}
      {showFooter && (
        <Box
          sx={{
            p: 2,
            textAlign: 'right',
            borderTop: `1px solid ${COLORS.WHITE}`,
            borderRadius: '0 0 8px 8px',
          }}
        >
          {footerContent || (
            <Button variant="contained" onClick={onSubmit} color="secondary">
              {submitButtonText || t(StringKeys.SAVE)}
            </Button>
          )}
        </Box>
      )}
    </Dialog>
  );
};

export default BaseModal;
